var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHostInstitutionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Host Institutions") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "host-institutions-icon",
    transform: "translate(-34.000000, -209.000000)",
    fill: "#66788A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu",
    transform: "translate(0.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.000000, 25.000000)",
    id: "menu.group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "navigation/icon/menu.item/default-copy",
    transform: "translate(0.000000, 108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy",
    transform: "translate(18.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "0 20.0011111 5 20.0011111 5 10 0 10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    points: "7.5 20.0011111 12.5 20.0011111 12.5 10 7.5 10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    points: "15 20.0011111 20 20.0011111 20 10 15 10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    points: "10 0 0 7.49888889 20 7.49888889"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHostInstitutionIcon);
export default __webpack_public_path__ + "static/media/host_institution_icon.1881b218706c9d8e2e5e324a9099475a.svg";
export { ForwardRef as ReactComponent };